import { Injectable } from '@angular/core';
import { RectangleSelectionService } from './rectangle-selection.service';
import { PdfInstanceManagerService } from './instance/pdf-instance-manager.service';
import { TabService } from './tab.service';
import { FileConvertorService } from './file-convertor/file-convertor-service';
import { PdfPageService } from './pdf-page.service';
import { CurrentUiStoreService } from './ui/current-ui-store.service';
import { AsgardFeatureNames } from '../../models/AsgardFeatures';
import { RemoveExtensionStringPipe } from '../utils/pipes/remove-extension-string.pipe';
import { BlobToPdfService } from './blob-to-pdf.service';
import { ImageToPdfConversion } from './file-convertor/conversions/img-to-pdf-conversion';

@Injectable({
  providedIn: 'root'
})
export class ScreenshotService {
  private screenshotCounter: number = 1;

  constructor(
    private rectSelSvc: RectangleSelectionService,
    private pdfManager: PdfInstanceManagerService,
    private tabSvc: TabService,
    private uiSvc: CurrentUiStoreService,
    private convertorSvc: FileConvertorService,
    private pdfPageSvc: PdfPageService,
    private removeExtension: RemoveExtensionStringPipe,
    private blobToPdfSvc: BlobToPdfService
  ) {
    this.mouseUpSub();

  }
  
  close = () => {
    this.uiSvc.setItemUnActive(AsgardFeatureNames.SCREENSHOT_READER);
  }

  takeScreenshot(): void {
    this.rectSelSvc.toggleRectSelect();
  }

  async mouseUpSub(): Promise<void> {
    this.rectSelSvc.MouseUpEvent.subscribe(async (coords) => {
      if (this.tabSvc.activeTab) {

        // original document, currently in viewer
        const viewerInstance = this.pdfManager.getViewerInstance(this.tabSvc.activeTab.id);
        const docViewer = await this.pdfManager.getDocViewer(this.tabSvc.activeTab.id);
        if (viewerInstance && docViewer) {
          // create copy to process for screenshot
          const screenshotCopyFile = await this.blobToPdfSvc.getCurrentPDF();
          const screenshotCopyPdfDoc = await this.blobToPdfSvc.convertFileToPdfDoc(screenshotCopyFile);
          if (screenshotCopyPdfDoc) {
            const pageToCrop = await screenshotCopyPdfDoc.getPage(docViewer.getCurrentPage());
            // get rect from original doc to get correct position of rect
            const rect = new viewerInstance.Core.PDFNet.Rect(coords.x1, coords.y1, coords.x2, coords.y2);
            const pageNumber = await pageToCrop.getIndex();

            // crop the page
            await pageToCrop.setCropBox(rect);
            // remove other pages
            const titleWithoutExt = this.removeExtension.transform(this.tabSvc.activeTab.title);
            const title = titleWithoutExt + '_screenshot_' + this.screenshotCounter;
            const updatedFile = await this.pdfPageSvc.extractPagesFromDocument(pageNumber, pageNumber, title, screenshotCopyPdfDoc);
            // send to ocr
            if (updatedFile) {
              // this.convertorSvc.getImageAndCreatePdf(updatedFile);
              this.convertorSvc.makeConversion<ImageToPdfConversion>(ImageToPdfConversion, {file: updatedFile});
            }
            // title has screenshot counter, counting per session
            this.screenshotCounter++;
          }
        }
      }

      // remove active-item from icon
      this.close();

    });
  }
}
